/* global axios */
import ApiClient from './ApiClient';

class ClaudiaTakeoverBatchesAPI extends ApiClient {
  constructor() {
    super('claudia/takeover_batches', { accountScoped: true });
  }

  show(batchId) {
    return axios.get(`${this.url}/${batchId}`);
  }

  retryFailed(batchId) {
    return axios.post(`${this.url}/${batchId}/retry_failed`);
  }
}

export default new ClaudiaTakeoverBatchesAPI();
